/* Cartwala banners: autoplay, manual controls, keyboard and mobile swipe. */
(function () {
  "use strict";
  function mount(root) {
    if (root.dataset.cwCarouselReady === "true") return;
    var slides = Array.from(root.querySelectorAll("[data-cw-banner-slide]"));
    var dots = Array.from(root.querySelectorAll("[data-cw-banner-dot]"));
    if (slides.length < 2) return;
    root.dataset.cwCarouselReady = "true";
    var current = 0, stopped = false, hovered = false, focused = false, timer = null;
    var interval = Math.max(4000, Number(root.dataset.interval) || 6000);
    var media = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    var announcement = root.querySelector("[data-cw-banner-announcement]");
    var count = root.querySelector("[data-cw-banner-counter]");
    var pause = root.querySelector("[data-cw-banner-pause]");
    var startX = null, startY = null;

    function isPaused() {
      return stopped || hovered || focused || document.hidden || !!(media && media.matches);
    }
    function render(next, isManual) {
      current = (next + slides.length) % slides.length;
      slides.forEach(function (slide,i) {
        var active = i === current;
        slide.hidden = !active;
        slide.classList.toggle("is-active",active);
        slide.setAttribute("aria-hidden", String(!active));
        if ("inert" in slide) slide.inert = !active;
      });
      dots.forEach(function (dot,i) {
        var active=i===current;
        dot.classList.toggle("is-active",active);
        dot.setAttribute("aria-current",String(active));
      });
      if (count) count.textContent = String(current+1).padStart(2,"0")+
        " / "+String(slides.length).padStart(2,"0");
      if (isManual && announcement) announcement.textContent =
        "Banner "+(current+1)+" of "+slides.length;
    }
    function clear() { if (timer !== null) { window.clearInterval(timer);timer=null; } }
    function schedule() {
      clear();
      if (!isPaused()) timer=window.setInterval(function () { render(current+1,false); },interval);
      if (pause) {
        pause.textContent = stopped ? "▶" : "Ⅱ";
        pause.setAttribute("aria-pressed",String(stopped));
        pause.setAttribute("aria-label",stopped?"Resume automatic banners":"Pause automatic banners");
      }
    }
    function go(n) {render(n,true);schedule();}
    root.querySelector("[data-cw-banner-prev]")?.addEventListener("click",function(){go(current-1)});
    root.querySelector("[data-cw-banner-next]")?.addEventListener("click",function(){go(current+1)});
    dots.forEach(function (dot,i){dot.addEventListener("click",function(){go(i)})});
    pause?.addEventListener("click",function(){stopped=!stopped;schedule()});
    root.addEventListener("mouseenter",function(){hovered=true;schedule()});
    root.addEventListener("mouseleave",function(){hovered=false;schedule()});
    root.addEventListener("focusin",function(){focused=true;schedule()});
    root.addEventListener("focusout",function(e){
      if (!root.contains(e.relatedTarget)){focused=false;schedule()}
    });
    root.addEventListener("keydown",function(e){
      if(e.key==="ArrowRight"){e.preventDefault();go(current+1)}
      else if(e.key==="ArrowLeft"){e.preventDefault();go(current-1)}
    });
    root.addEventListener("touchstart",function(e){
      if(e.touches.length!==1){startX=null;return}
      startX=e.touches[0].clientX;startY=e.touches[0].clientY;
    },{passive:true});
    root.addEventListener("touchend",function(e){
      if(startX===null||e.changedTouches.length!==1)return;
      var dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;
      startX=null;
      if(Math.abs(dx)>48&&Math.abs(dx)>Math.abs(dy)*1.3)go(current+(dx<0?1:-1));
    },{passive:true});
    document.addEventListener("visibilitychange",schedule);
    if(media&&media.addEventListener)media.addEventListener("change",schedule);
    document.addEventListener("shopify:section:unload",function(e){
      if(e.target&&e.target.contains(root))clear();
    });
    render(0,false);schedule();
  }
  function init(){
    document.querySelectorAll("[data-cw-banner-carousel]").forEach(mount);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});
  else init();
  document.addEventListener("shopify:section:load",init);
})();